import { useLayoutEffect } from "react"
import { useLocation } from "react-router-dom"
import { trackEvent } from "@/lib/analytics/track"

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
    trackEvent('$pageview', { path: pathname })
  }, [pathname])

  return null
}

export default ScrollToTop